import React, { Component } from "react";
import "react-datepicker/dist/react-datepicker.css";

import { Switch, Route, Link } from "react-router-dom";
import SearchComponent from "./SearchComponent";

export default class TripSearch extends Component {
  handleSubmit = e => {
    e.preventDefault();
  };
  render() {
    return (
      <React.Fragment>
        <form onSubmit={this.handleSubmit}>
          <div className="trip-search-section">
            <ul className="flight-type">
              <li>
                <Link to={{ pathname: "/", search: "flight-search" }}>
                  <i className="fa fa-plane"></i>
                  <h4>Flight</h4>
                </Link>
              </li>
              <li>
                <Link to={{ pathname: "/", search: "umrah-flight-search" }}>
                  <i className="fa fa-building"></i>
                  <h4>Umrah Flight</h4>
                </Link>
              </li>
              <li>
                <Link to={{ pathname: "/", search: "group-flight-search" }}>
                  <i className="fa fa-group"></i>
                  <h4>Group Flight</h4>
                </Link>
              </li>
            </ul>
            <div className="search-content">
              <Switch>
                <Route component={SearchComponent} />
                <Route component={SearchComponent} />
                <Route component={SearchComponent} />
              </Switch>
            </div>
            <button type="submit" className="btn btn-primary">
              Search
            </button>
          </div>
        </form>
      </React.Fragment>
    );
  }
}
